import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { ServiceComboDefinition } from "@/Common/Api/Services/Dto/Responses/ServiceDefinition";
import { ServiceDefinitionDTO } from "@/Common/Api/Services/Dto/ServiceDefinitionDTO";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";

class ServiceComboResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);
        this.RegisterOperation(ServerOperations.Server.Myle_AdministrationUpsertService, this.upsertService);
        this.RegisterOperation(ServerOperations.Server.Myle_AdministrationUpsertCombo, this.upsertCombos);
    }

    private upsertService(response: ServerEvent, store: AdministrationStore): void {
        let newServiceDefinition: ServiceDefinitionDTO = response.Data.UpsertedService;

        // refresh all lookups
        for (const lookup of response.Data.Lookups ?? [])
            cacheStore.rebindLookup(new FlatLookupView(lookup));

        // refresh service in cache store's service cache
        cacheStore.rebindServiceToCache(newServiceDefinition);

        // close dialog & overlay
        store.serviceComboGridModel = store.serviceComboGridModel.set("DisplayEditServiceComponent", false);
        store.serviceComboGridModel = store.serviceComboGridModel.set("DisplayPortalDetailsComponent", false);
        sessionStore.hideGlobalOverlay();

        // refresh grid without reload
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.RefreshGrid);
        LocalEventDispatcher.dispatch(operation);
    }

    private upsertCombos(response: ServerEvent, store: AdministrationStore): void {
        // refresh grid with reload
        let isSuccess = response.Data.IsSuccess;

        // refresh all lookups
        for (const lookup of response.Data.Lookups ?? [])
            cacheStore.rebindLookup(new FlatLookupView(lookup));

        // refresh combo in cache store's service combo cache
        if (isSuccess && response.Data.UpsertedCombo != null) {
            let newComboDefinition: ServiceComboDefinition = response.Data.UpsertedCombo;
            newComboDefinition.ComboId = response.Data.UpsertedCombo.Id; // Hack....

            cacheStore.rebindServiceComboDefinitionToCache(newComboDefinition);
        }

        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.RefreshGrid);
        LocalEventDispatcher.dispatch(operation);
        // close dialog & overlay
        store.serviceComboGridModel = store.serviceComboGridModel.set("DisplayEditServiceComponent", false);
        store.serviceComboGridModel = store.serviceComboGridModel.set("DisplayPortalDetailsComponent", false);
        sessionStore.hideGlobalOverlay();
    }
}

export { ServiceComboResponseHandler };
